import { DimeExperience } from '@office-start/dime-types';
import { showErrorDialog } from '@office-start/error-dialog-service';
import { KnownInstrumentationEvents } from '@office-start/instrumentation-types';
import { logUserAction } from '@office-start/telemetry-service';
import { useCallback, useMemo } from 'react';
import { useIsShowStorageErrorDialogApplicable } from './useIsShowStorageErrorDialogApplicable';
import { useManageStorage } from './useManageStorage';
import { useUpsellButtonProps } from './useUpsellButtonProps';
export var useShowStorageErrorDialog = function () {
    var isShowStorageErrorDialogApplicable = useIsShowStorageErrorDialogApplicable();
    var manageStorageProps = useManageStorage();
    var upsellButtonProps = useUpsellButtonProps(DimeExperience.WelcomeBadge);
    var defaultErrorDialogProps = useMemo(function () {
        return {
            category: 'CreateFile',
            error: 'UserStorageQuotaFull',
        };
    }, []);
    var showStorageErrorDialogAppList = useMemo(function () { return ['Word', 'PowerPoint', 'Excel']; }, []);
    var errorDialogProps = useMemo(function () {
        var options = Object.assign({}, defaultErrorDialogProps);
        if (upsellButtonProps &&
            upsellButtonProps.showDime &&
            upsellButtonProps.onClick) {
            options = Object.assign(options, {
                onActionClicked: function () {
                    return upsellButtonProps.onClick('StorageQuota');
                },
            });
        }
        if (manageStorageProps && manageStorageProps.link) {
            options = Object.assign(options, {
                fallbackSiteUrl: manageStorageProps.link,
            });
        }
        return options;
    }, [defaultErrorDialogProps, manageStorageProps, upsellButtonProps]);
    var showStorageErrorDialog = useCallback(function (option) {
        var workloadId = option.workloadId, area = option.area, subArea = option.subArea, isTemplate = option.isTemplate;
        if (manageStorageProps && manageStorageProps.link && workloadId) {
            // log click action now as showing dialog
            logUserAction({
                eventName: !!isTemplate
                    ? KnownInstrumentationEvents.TemplateClick
                    : KnownInstrumentationEvents.CreateLinkClick,
                id: workloadId,
                area: area,
                subArea: subArea,
                result: 'Navigate',
                target: 'Other',
            });
            logUserAction({
                eventName: KnownInstrumentationEvents.ShowStorageErrorDialog,
                id: workloadId,
                area: area,
                subArea: subArea,
                result: 'Block',
                target: 'Other',
            });
            showErrorDialog(errorDialogProps);
        }
    }, [errorDialogProps, manageStorageProps]);
    var shouldShowStorageErrorDialog = useCallback(function (appName) {
        if (!appName)
            return false;
        return (isShowStorageErrorDialogApplicable &&
            showStorageErrorDialogAppList.indexOf(appName) >= 0);
    }, [isShowStorageErrorDialogApplicable, showStorageErrorDialogAppList]);
    return useMemo(function () { return [showStorageErrorDialog, shouldShowStorageErrorDialog]; }, [shouldShowStorageErrorDialog, showStorageErrorDialog]);
};
//# sourceMappingURL=useShowStorageErrorDialog.js.map